import type { CSSProperties } from "react";
import type { Theme } from "@structurify/shared-types";

interface Props {
  theme: Theme;
  vertical?: boolean;
  style?: CSSProperties;
}

export function Rule({ theme, vertical, style }: Props) {
  return (
    <div
      style={{
        background: theme.rule,
        width: vertical ? 1 : "100%",
        height: vertical ? "100%" : 1,
        flex: vertical ? "0 0 1px" : "none",
        ...style,
      }}
    />
  );
}
